import { render, staticRenderFns } from "./ColonReportBowelCleanseForms.vue?vue&type=template&id=7ef6f0e3&"
import script from "./ColonReportBowelCleanseForms.vue?vue&type=script&lang=js&"
export * from "./ColonReportBowelCleanseForms.vue?vue&type=script&lang=js&"
import style0 from "./ColonReportBowelCleanseForms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VContainer,
  VFlex,
  VLayout,
  VTextarea,
})
